import { gql } from "@apollo/client";

const schema = {
  create: {
    name: "addUser",
    serviceName: "unitadmin",
    query: gql`
      mutation addUser(
        $lastname: String
        $firstname: String
        $cellphone: String!
        $birth_date: String
        $national_code: String
        $need_activation: Int
        $type_id: String
        $gender: Int
        $user_category_id: String
      ) {
        addUser(
          lastname: $lastname
          firstname: $firstname
          cellphone: $cellphone
          birth_date: $birth_date
          national_code: $national_code
          need_activation: $need_activation
          type_id: $type_id
          gender: $gender
          user_category_id: $user_category_id
        ) {
          messages
        }
      }
    `,
  },
};

export default schema;
